export function SurveilLogo({ className }: { className?: string }) {
  return (
    <img src="/logo.svg" alt="Surveil Logo" className={className} />
  );
}
